import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Plus } from 'lucide-react';
import styles from './FAQ.module.css';

export const FAQ_ITEMS = [
    ['Do I need to install anything?', 'No. Hirsta runs in the browser on a computer, tablet or phone. Open app.hirsta.com and log in.'],
    ['Does it handle GST?', 'Yes. Inclusive or exclusive pricing, CGST and SGST on every line, your GSTIN on the bill, and a GST report ready for your CA. Services paid from a prepaid card or a package are shown as advance adjusted, so GST is not charged twice.'],
    ['I have more than one branch. Will it work?', 'Yes. Head office sees every branch, can compare them, and sets limits that each branch must follow. Staff only see the branch they work in.'],
    ['Can I control what my staff can see and do?', 'Yes. Give each person View, Create, Edit or Delete for every module, set maximum discount and back-dated bills, and hide client phone numbers. Every action is checked on the server too.'],
    ['How do packages work?', 'Sell a package on a bill. On each visit, tap Use and the service is added at ₹0. Hirsta tracks services left, expiry and every visit, and gives credit to the stylist who served it.'],
    ['Can bills be sent on WhatsApp?', 'Yes. Share a bill on WhatsApp, SMS or email in one tap. The client opens it with your logo, downloads the PDF and can pay the balance by UPI.'],
];

export default function FAQ() {
    const [open, setOpen] = useState(0);
    return (
        <div className={styles.list}>
            {FAQ_ITEMS.map(([q, a], i) => {
                const isOpen = open === i;
                return (
                    <div key={q} className={`${styles.item} ${isOpen ? styles.open : ''}`}>
                        <button type="button" className={styles.q} onClick={() => setOpen(isOpen ? -1 : i)} aria-expanded={isOpen}>
                            <span>{q}</span>
                            <motion.span animate={{ rotate: isOpen ? 45 : 0 }} transition={{ duration: 0.2 }} className={styles.plus}><Plus size={16} /></motion.span>
                        </button>
                        <AnimatePresence initial={false}>
                            {isOpen && (
                                <motion.div
                                    initial={{ height: 0, opacity: 0 }}
                                    animate={{ height: 'auto', opacity: 1 }}
                                    exit={{ height: 0, opacity: 0 }}
                                    transition={{ duration: 0.28, ease: [0.22, 1, 0.36, 1] }}
                                    className={styles.aWrap}
                                >
                                    <p className={styles.a}>{a}</p>
                                </motion.div>
                            )}
                        </AnimatePresence>
                    </div>
                );
            })}
        </div>
    );
}
